import {OFFERING_TYPE} from "./constant";

export const convertOfferingToName = (offeringType: OFFERING_TYPE) => {
  return {
    [OFFERING_TYPE.SERVICE]: "Service",
    [OFFERING_TYPE.PRODUCT]: "Product",
    [OFFERING_TYPE.ORGANIZATION]: "Organization",
    [OFFERING_TYPE.SECONDMENT]: "Secondment",
  }[offeringType];
};
